import styled from 'styled-components';
var ModalFooter = styled.div.withConfig({
  displayName: "Footerstyles__ModalFooter",
  componentId: "sc-11vcmlf-0"
})(["background:var(--dentsu-color-n50);padding:var(--dentsu-spacing-16) var(--dentsu-spacing-24);display:flex;justify-content:flex-end;flex:0 0 auto;margin:0;button{margin-left:var(--dentsu-spacing-8);}button:nth-last-child(2):first-child,button:nth-last-child(3):first-child{margin-right:auto;margin-left:0;}"]);
export var Styled = {
  ModalFooter: ModalFooter
};